<template>
  <div>
    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for creating new checks -->
    <div
      class="modal fade"
      id="checkManagementFilterModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.CM1074 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th
                      style="width: 90px"
                      v-for="(header, index) in langShort"
                      :key="index"
                    >
                      <div v-if="header != 'Save' && header != 'Speichern'">
                        {{ header }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><input type="checkbox" v-model="items.SID" /></td>
                    <td><input type="checkbox" v-model="items.CheckID" /></td>
                    <td><input type="checkbox" v-model="items.CheckCode" /></td>
                    <td><input type="checkbox" v-model="items.Status" /></td>
                    <td><input type="checkbox" v-model="items.Project" /></td>
                    <td><input type="checkbox" v-model="items.Wave" /></td>
                    <td><input type="checkbox" v-model="items.Scenario" /></td>
                    <td><input type="checkbox" v-model="items.CheckInfo" /></td>
                    <td><input type="checkbox" v-model="items.StoreID" /></td>
                    <td>
                      <input type="checkbox" v-model="items.LocationName" />
                    </td>
                    <td><input type="checkbox" v-model="items.Address" /></td>
                    <td><input type="checkbox" v-model="items.Country" /></td>
                    <td><input type="checkbox" v-model="items.Visit" /></td>
                    <td>
                      <input type="checkbox" v-model="items.Internalnote" />
                    </td>
                    <td>
                      <input type="checkbox" v-model="items.ExpiryDate" />
                    </td>
                    <td><input type="checkbox" v-model="items.Agency" /></td>
                    <td><input type="checkbox" v-model="items.Shopper" /></td>
                    <td><input type="checkbox" v-model="items.Score" /></td>
                    <td><input type="checkbox" v-model="items.Progress" /></td>
                    <td>
                      <input type="checkbox" v-model="items.Modifiedat" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Save button on the right -->
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveCustomSettingsList()"
            >
              {{ lang.CM1026 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CheckManagementFilterModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      headers: [
        "SID",
        "CheckID",
        "CheckCode",
        "Status",
        "Project",
        "Wave",
        "Scenario",
        "CheckInfo",
        "StoreID",
        "LocationName",
        "Address",
        "Country",
        "Visit",
        "Internalnote",
        "ExpiryDate",
        "Agency",
        "Shopper",
        "Score",
        "Progress",
        "Modifiedat",
      ],
      items: [],
      languageStringsReceived: false,
      langShort: {},
      lang: {
        // Contains localization strings for the selected language
        CM0015: "SID",
        CM0016: "Check ID",
        CM0017: "Survey Code",
        CM0018: "Status",
        CM0019: "Project",
        CM0020: "Wave",
        CM0021: "Scenario",
        CM0073: "Check Info",
        CM0050: "StoreID",
        CM0051: "Location Name",
        CM0022: "Address",
        CM0023: "Country",
        CM0024: "Visit",
        CM0027: "Internal note",
        CM0028: "Expiry Date",
        CM0065: "Agency",
        CM0079: "Shopper",
        CM0030: "Score",
        CM0031: "Progress",
        CM0047: "Modified At",
        CM1026: "Save",
        CM1074: "Custom settings",
      },
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.getCustomSettingsList();
        this.getLanguageShort();
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    "globals.selectedLanguage"() {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    }
    this.getLanguageShort();
    $("#checkManagementFilterModal").on("hide.bs.modal", (e) =>
      this.$emit("closeModal")
    );
  },
  methods: {
    openModal() {
      this.$nextTick(() => {
        $("#checkManagementFilterModal").modal("show");
      });
    },
    closeModal() {
      $("#checkManagementFilterModal").modal("hide");
    },
    getLanguageShort() {
      this.langShort = Object.fromEntries(
        Object.entries(this.lang).filter(([key]) => key.includes("CM0"))
      );
    },
    getCustomSettingsList() {
      $.ajax({
        method: "GET",
        url: "api/Data/CustomSettings",
        success: (data) => {
          this.items = data;
        },
        error: () => {
          console.error(
            "Custom settings data access failed in getCustomSettingsList()"
          );
          this.globals.showErrorSnackbar("Custom settings data access failed");
        },
      });
    },
    saveCustomSettingsList() {
      console.log(JSON.stringify(this.items));
      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/CustomSettings",
        data: JSON.stringify(this.items),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Custom Settings saved!");
          this.closeModal();
        },
        error: () => {
          console.error("Error on POST in saveCustomSettingsList()");
          this.globals.showErrorSnackbar("Custom Settings not saved!");
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#checkManagementFilterModal > .modal-dialog {
  width: calc(100vw - 30px);
}
</style>



// WEBPACK FOOTER //
// CheckManagementFilterModal.vue?550823f4